"use client";

// PostHog — ürün analitiği + oturum kaydı. GA4/Meta/TikTok/Yandex yanına
// 5. piksel olarak merkezi analytics katmanından beslenir.
// KVKK: init + kayıt yalnızca analitik onayı varsa (Analytics.tsx ile aynı kapı).

import posthog from "posthog-js";

export function getPostHogConfig(): { key: string | null; host: string } {
  // İki ad da kabul edilir (kurulum dokümanındaki PROJECT_TOKEN dahil)
  const key =
    process.env.NEXT_PUBLIC_POSTHOG_KEY?.trim() ||
    process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN?.trim() ||
    null;
  const host = process.env.NEXT_PUBLIC_POSTHOG_HOST?.trim() || "https://eu.posthog.com";
  return { key, host };
}

let initialized = false;
// posthog tarafındaki gerçek opt durumu (init sonrası). Aynı yöne tekrar
// çağrılar yutulur — aksi halde her storage/consent olayında opt_in/out
// + startSessionRecording yeniden koşar, SDK istemci rate-limit'e takılıp
// konsolu sel basar ve sekmeler arası ping-pong büyür.
let optedIn: boolean | null = null;

export function isPostHogReady(): boolean {
  return initialized && typeof window !== "undefined";
}

/** Bir kez init edilir; onay yoksa kayıt kapalı başlar (provider opt-in yapar). */
export function initPostHog(): boolean {
  if (initialized || typeof window === "undefined") return initialized;
  const { key, host } = getPostHogConfig();
  if (!key) return false;
  try {
    posthog.init(key, {
      api_host: host,
      // Sayfa görüntüleme RouteTracker'dan manuel gider (çift sayım yok)
      capture_pageview: false,
      capture_pageleave: true,
      autocapture: true,
      disable_session_recording: true,
      opt_out_capturing_by_default: true,
      persistence: "localStorage",
    });
    initialized = true;
    return true;
  } catch {
    return false;
  }
}

export function posthogOptIn(): void {
  if (!isPostHogReady() || optedIn === true) return;
  try {
    posthog.opt_in_capturing();
    posthog.startSessionRecording();
    optedIn = true;
  } catch {}
}

export function posthogOptOut(): void {
  if (!isPostHogReady() || optedIn === false) return;
  try {
    posthog.stopSessionRecording();
    posthog.opt_out_capturing();
    optedIn = false;
  } catch {}
}

/** Analytics.tsx ile aynı kapı: tam kabul veya özel+analitik. */
function analyticsConsented(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const raw = localStorage.getItem("onomac-cookie-consent");
    if (raw === "accepted") return true;
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed?.status === "accepted" || (parsed?.status === "custom" && !!parsed.analytics);
  } catch {
    return false;
  }
}

/** Merkezi olay aynası — analytics.ts huni fonksiyonlarından çağrılır. */
export function trackPostHog(event: string, props?: Record<string, unknown>): void {
  if (!isPostHogReady() || !analyticsConsented()) return;
  try {
    posthog.capture(event, props);
  } catch {}
}

export function posthogPageview(url: string): void {
  if (!isPostHogReady() || !analyticsConsented()) return;
  try {
    posthog.capture("$pageview", { $current_url: url });
  } catch {}
}
